/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import React, { useState } from 'react';
import {
  IconButton,
  Popover,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Typography
} from '@mui/material';
import TuneIcon from '@mui/icons-material/Tune';

const SearchFilterPopover = ({ searchMode, setSearchMode }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'search-filter-popover' : undefined;

  return (
    <>
      <IconButton
        aria-describedby={id}
        onClick={handleClick}
        sx={{
          backgroundColor: open ? '#dbeefd' : '#f0f4f9',
          borderRadius: 2,
          p: 1,
          '&:hover': {
            backgroundColor: '#d0e3ff',
          },
        }}
      >
        <TuneIcon sx={{ color: '#1a1b1f' }} />
      </IconButton>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        PaperProps={{
          elevation: 3,
          sx: {
            mt: 1,
            p: 2,
            borderRadius: 3,
            minWidth: 180,
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
          },
        }}
      >
        <FormControl component="fieldset">
          <FormLabel
            component="legend"
            sx={{
              fontWeight: 700,
              color: '#344054',
              mb: 1,
              '&.Mui-focused': { color: '#344054' }
            }}
          >
            Search Mode:
          </FormLabel>
          <RadioGroup
            value={searchMode}
            onChange={(e) => setSearchMode(e.target.value)}
          >
            <FormControlLabel
              value="semantic"
              control={<Radio size="small" />}
              label={<Typography sx={{ fontWeight: 600, fontSize: '0.9rem', color: '#344054' }}>Semantic enhanced</Typography>}
            />
            <FormControlLabel
              value="full-text"
              control={<Radio size="small" />}
              label={<Typography sx={{ fontWeight: 600, fontSize: '0.9rem', color: '#344054' }}>Exact match</Typography>}
            />
          </RadioGroup>
        </FormControl>
      </Popover>
    </>
  );
}
//
export default SearchFilterPopover;